/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import BaseStopStationIcon from '#/shared/components/BaseStopStationIcon';
import SvgMapMarkerSolid from '#/shared/components/GeneratedIcons/trimet/SelectedLocationMarker';

function LocationResultIcon({ type, ...props }) {
  return {
    stop: <BaseStopStationIcon isSolid {...props} />,
    default: <SvgMapMarkerSolid {...props} />,
  }[type];
}

LocationResultIcon.propTypes = {
  type: PropTypes.oneOf(['stop', 'default']),
};

LocationResultIcon.defaultProps = {
  type: 'default',
};

export default LocationResultIcon;
